import type { LucideIcon } from 'lucide-react';
import { User, MapPin, Sword, Shield, Scroll, BookOpen } from 'lucide-react';
import type { JournalEntryType, JournalData, JournalNpcData, JournalLocationData, JournalQuestData, JournalFactionData, JournalHandoutData, JournalLoreData } from '@roll1/shared';

export const JOURNAL_TYPE_ICONS: Record<JournalEntryType, LucideIcon> = {
  npc: User,
  location: MapPin,
  quest: Sword,
  faction: Shield,
  handout: Scroll,
  lore: BookOpen,
};

export const JOURNAL_TYPE_LABELS: Record<JournalEntryType, string> = {
  npc: 'NPC',
  location: 'Локация',
  quest: 'Квест',
  faction: 'Фракция',
  handout: 'Хендаут',
  lore: 'Знания',
};

export function getDefaultData(type: JournalEntryType): JournalData {
  switch (type) {
    case 'npc':
      return {
        disposition: 'neutral',
        description: '',
        personality: '',
        secrets: '',
        questHooks: [],
        alive: true,
      } satisfies JournalNpcData;
    case 'location':
      return {
        description: '',
        secrets: '',
      } satisfies JournalLocationData;
    case 'quest':
      return {
        status: 'active',
        description: '',
        gmNotes: '',
        objectives: [],
        // The key is there from the start: opening the quest to players takes
        // the fields it has, so rewards written later are not cut off.
        rewards: '',
      } satisfies JournalQuestData;
    case 'faction':
      return {
        description: '',
        attitude: '',
        secrets: '',
      } satisfies JournalFactionData;
    case 'handout':
      return {
        content: '',
        gmNotes: '',
      } satisfies JournalHandoutData;
    case 'lore':
      return {
        category: '',
        content: '',
        gmNotes: '',
      } satisfies JournalLoreData;
  }
}
